import { Loader } from '@calendly/ui/components/loader';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c15qrdkc";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const LoadingState = () => <Container>
    <Loader data-testid="loader" />
  </Container>;
export const LoadingWrapper = ({
  isLoading,
  children
}) => isLoading ? <LoadingState /> : children;
export default LoadingState;

require("./loading_state.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./loading_state.js");